import { Stack, Textarea } from "@financeable-com-au/financeable-ui";
import { InvoiceNotesProps } from "@/utils/interface";
import { INVOICE_SECTIONS } from "@/constants";
import SectionCard from "./SectionCard";

const InvoiceNotes = ({ value, onChange, disabled }: InvoiceNotesProps) => {
  return (
    <SectionCard title={INVOICE_SECTIONS.invoiceNotes} subtitle="Visible under invoice overview.">
      <Stack>
        <Textarea
          minRows={3}
          placeholder="e.g. Additional notes for the invoice."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          sx={{ width: "100%" }}
        />
      </Stack>
    </SectionCard>
  );
};

export default InvoiceNotes;
